import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { ButtonGroup, Button } from 'react-bootstrap';

import Colorpicker from './Colorpicker';

export default class TableControls extends React.PureComponent {
    static propTypes = {
        innerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
        addColumn: PropTypes.func.isRequired,
        removeColumn: PropTypes.func.isRequired,
        addRow: PropTypes.func.isRequired,
        removeRow: PropTypes.func.isRequired,
        toggleBold: PropTypes.func.isRequired,
        toggleItalic: PropTypes.func.isRequired,
        toggleColspan: PropTypes.func.isRequired,
        undo: PropTypes.func.isRequired,
        redo: PropTypes.func.isRequired,
        undoable: PropTypes.bool,
        redoable: PropTypes.bool,
    };

    static defaultProps = {
        innerRef: null,
        undoable: false,
        redoable: false,
    };

    state = {
        colorpicker: false,
    };

    colorButtons = React.createRef();

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    showColorpicker = (e) => {
        const { name } = e.currentTarget;

        this.setState({
            colorpicker: true,
            colorpickerType: name,
        });
    };

    hideColorpicker = () => {
        this.setState({
            colorpicker: false,
        });
    };

    handleClickOutside = (e) => {
        if (this.colorButtons && !this.colorButtons.current.contains(e.target)) {
            this.hideColorpicker();
        }
    };

    handleAlignmentChange = (e) => {
        const { name } = e.currentTarget;
        const { setAlignment } = this.props;

        setAlignment(name);
    };

    handleColorChange = (color) => {
        this.props.setColor(color);
        this.hideColorpicker();
    };

    render() {
        const { colorpicker, colorpickerType } = this.state;
        const {
            innerRef, addColumn, removeColumn, addRow, removeRow,
            toggleBold, toggleItalic, toggleColspan,
            undo, redo, undoable, redoable, unspanable,
        } = this.props;

        return (
            <div className="table-controls" ref={innerRef}>
                <div className="table-controls__layout">
                    <ButtonGroup className="mr-2" aria-label="Add group" size="sm">
                        <Button onClick={addColumn} title="Добавить колонку" variant="outline-primary"><FontAwesomeIcon icon="arrow-right" /></Button>
                        <Button onClick={addRow} title="Добавить строку" variant="outline-primary"><FontAwesomeIcon icon="arrow-down" /></Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2" aria-label="Remove group" size="sm">
                        <Button onClick={removeRow} title="Удалить строку" variant="outline-danger"><FontAwesomeIcon icon="arrow-up" /></Button>
                        <Button onClick={removeColumn} title="Удалить колонку" variant="outline-danger"><FontAwesomeIcon icon="arrow-left" /></Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2" aria-label="UndoRedo group" size="sm">
                        <Button onClick={undo} name="undo" title="Отменить действие" variant="outline-secondary" disabled={!undoable}><FontAwesomeIcon icon="undo" /></Button>
                        <Button onClick={redo} name="redo" title="Повторить действие" variant="outline-secondary" disabled={!redoable}><FontAwesomeIcon icon="redo" /></Button>
                    </ButtonGroup>
                </div>
                <div className="table-controls__content">
                    <ButtonGroup className="mr-2" aria-label="Font group" size="sm">
                        <Button onClick={toggleBold} title="Жирный" variant="outline-secondary"><FontAwesomeIcon icon="bold" /></Button>
                        <Button onClick={toggleItalic} title="Курсив" variant="outline-secondary"><FontAwesomeIcon icon="italic" /></Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2" aria-label="Alignment group" size="sm">
                        <Button onClick={this.handleAlignmentChange} name="left" title="По левому краю" variant="outline-secondary"><FontAwesomeIcon icon="align-left" /></Button>
                        <Button onClick={this.handleAlignmentChange} name="center" title="По центру" variant="outline-secondary"><FontAwesomeIcon icon="align-center" /></Button>
                        <Button onClick={this.handleAlignmentChange} name="right" title="По правому краю" variant="outline-secondary"><FontAwesomeIcon icon="align-right" /></Button>
                    </ButtonGroup>
                    <ButtonGroup className="mr-2" aria-label="Span group" size="sm">
                        <Button onClick={toggleColspan} name="collspan" title="Объединение ячеек" disabled={unspanable} variant="outline-secondary"><FontAwesomeIcon icon="compress" /></Button>
                    </ButtonGroup>
                    <ButtonGroup ref={this.colorButtons} className="" aria-label="Color group" size="sm">
                        <Button name="color" title="Цвет текста" variant="outline-secondary" onClick={this.showColorpicker}><FontAwesomeIcon icon="tint" /></Button>
                        <Button name="background" title="Цвет фона" variant="outline-secondary" onClick={this.showColorpicker}><FontAwesomeIcon icon="fill-drip" /></Button>
                        { colorpicker && <Colorpicker type={colorpickerType} onChange={this.handleColorChange} /> }
                    </ButtonGroup>
                </div>
            </div>
        );
    }
}
